import { SHOPIFY_STORE_DOMAIN, SHOPIFY_STOREFRONT_API_TOKEN } from '@portal/config/base';
import { mapStoreCodeToCountryCode } from '@portal/state/hooks/useStoreCountryCode';
import { StoreCode } from 'schema/storeCode';
import { cartCreateMutation } from '../mutations/cartCreate';
import { MULTICURRENCY_STORES } from '../storeCode';
import { CartInput } from '../types';
import { formatCartLines, shopifyFetch } from '../utils';

async function cartCreate({
  domain,
  token,
  cartInput
}: {
  cartInput: CartInput;
  domain: string;
  token: string;
}): Promise<{
  cost: any;
  lines: any;
  id: string;
  checkoutUrl: string | null;
}> {
  const res = await shopifyFetch<any>({
    query: cartCreateMutation,
    shopifyDomain: domain,
    accessToken: token,
    variables: {
      cartInput
    }
  });

  return {
    ...res.body.data.cartCreate.cart,
    lines: formatCartLines(res.body.data.cartCreate.cart),
    checkoutUrl: res.body.data.cartCreate.cart.checkoutUrl ?? null
  };
}

export const createShopifyCart = async (
  storeCode: StoreCode,
  cartInput: CartInput
): Promise<{ id: string; cost: any; lines: any; checkoutUrl: string | null }> => {
  const isMultiCurrency = MULTICURRENCY_STORES.includes(storeCode);

  const adjustedCartInput = {
    ...cartInput,
    buyerIdentity: {
      ...cartInput.buyerIdentity,
      ...(isMultiCurrency &&
        !cartInput.buyerIdentity?.countryCode && {
          countryCode: mapStoreCodeToCountryCode(storeCode)
        })
    }
  };
  const cart = await cartCreate({
    domain: SHOPIFY_STORE_DOMAIN[storeCode],
    token: SHOPIFY_STOREFRONT_API_TOKEN[storeCode],
    cartInput: adjustedCartInput
  });

  return { ...cart, cost: cart.cost, lines: cart.lines, checkoutUrl: cart.checkoutUrl ?? null };
};
